import ReducedLandlordInformation from './ReducedLandlordInformation';

export default ReducedLandlordInformation;
